import { useState } from "react";
import { DownloadItem, useDownloadFile } from "utils";

export const useMostRecentDownloadStatus = (filename: string | undefined) => {
  const { getDownloadingStatus } = useDownloadFile();

  const [mostRecentStatus, setMostRecentStatus] = useState<
    DownloadItem["status"] | undefined
  >();

  if (filename) {
    const status = getDownloadingStatus(filename);

    if (status && status !== mostRecentStatus) {
      setMostRecentStatus(status);
    }
  }

  return mostRecentStatus;
};
